const UPPERCASE_TOKENS = new Set(["bb", "cc"])

/**
 * Turns raw API product-type enum values ("CONTOUR", "BB_CC_CREAM") into
 * sentence-case labels ("Contour", "BB CC cream").
 */
export const formatProductTypeName = (value: string): string => {
  const label = value
    .trim()
    .toLowerCase()
    .split(/[_\s]+/)
    .filter(Boolean)
    .map((word) => (UPPERCASE_TOKENS.has(word) ? word.toUpperCase() : word))
    .join(" ")

  return label.charAt(0).toUpperCase() + label.slice(1)
}
